export const apiLicenseCategoryRoutes = {
  routeLicenseCategories: 'driver/category/',
};